import React from 'react';
import * as Indicadores from '../../constantes/IndicadoresMovimientosEquipos.js';

const CampoComboMovimiento = (props) => {
  const estilo = props.estilo;
  const editar = props.editar;
  const nombre = props.nombre;
  const valor = props.valor;

  const onChangeHandler = (event) => {
    const newValue = event.target.value === '' ? null : event.target.value;
    props.onChange(nombre, newValue);
  };

  const opciones = [
    { value: '', label: '-' },
    { value: Indicadores.ASCENSO, label: 'Asc' },
    { value: Indicadores.ASCENSO_X_PROMEDIO, label: 'Asc Promo' },
    { value: Indicadores.DESCENSO, label: 'Desc' },
    { value: Indicadores.DESCENSO_X_PROMEDIO, label: 'Desc Promo' },
  ];

  if (editar) {
    return (
      <select className={`${estilo}`} value={valor || ''} onChange={onChangeHandler}>
        {opciones.map((opcion) => (
          <option key={opcion.value} value={opcion.value}>
            {opcion.label}
          </option>
        ))}
      </select>
    );
  } else {
    const opcionSeleccionada = opciones.find((o) => o.value === valor);
    return <span>{opcionSeleccionada ? opcionSeleccionada.label : ''}</span>;
  }
};

export default CampoComboMovimiento;
